import React from 'react';
import { useLocation } from 'react-router-dom';

import { useSelector } from 'react-redux';

import { Layout, Row, Col } from 'antd';

import MenuHeader from './components/header';
import MenuFooter from './components/footer';
import ScrollTop from './components/scroll-to-top';
import AdminNavigationBar from './components/content/AdminNavigationBar';

const { Content } = Layout;

export default function VerticalLayout(props) {
  const { children } = props;

  const { pathname } = useLocation();
  const isAdminRoute = pathname === '/admin' || pathname.startsWith('/admin/');

  // Redux
  const customise = useSelector((state) => state.customise);

  return (
    <Layout className="hp-app-layout">
      <Layout className="hp-bg-black-10 hp-bg-color-dark-90">
        <MenuHeader />

        <Content className={`hp-content-main ${isAdminRoute ? 'oekfb-admin-route' : ''}`}>
          <Row justify="center" gap={16}>
            {customise.contentWidth === 'full' && (
              <Col xxl={23} xl={22} span={24}>
                <AdminNavigationBar />
                {children}
              </Col>
            )}

            {customise.contentWidth === 'boxed' && (
              <Col className="hp-w-100" style={{ maxWidth: 936 }}>
                <AdminNavigationBar />
                {children}
              </Col>
            )}
          </Row>
        </Content>

        <MenuFooter />
      </Layout>

      <ScrollTop />
    </Layout>
  );
}
